export default __webpack_public_path__ + "static/media/Icon-rotate-alt-left.a02a7ae9.svg";